import { request } from '../utils/httpClientTs';
import { Report, ReportResponse, ReportData } from '../types/reports';

export interface ReportInfoData {
  reportId: string;
}

export const getReportList = (): Promise<Report[]> =>
  request({
    url: '/reports/',
    method: 'GET',
  });

export const getReportInfo = (data: ReportInfoData) =>
  request({
    url: `/reports/${data.reportId}`,
    method: 'GET',
  });

export const getReport = (data: ReportData): Promise<ReportResponse> => {
  let url = data.url;
  delete data.url;
  return request({
    url: `${url}`,
    method: 'POST',
    data: data.data,
  });
};

export const getReportExcel = (data: ReportData): Promise<Blob> => {
  let url = data.url;
  delete data.url;
  return request({
    url: `${url}/download`,
    method: 'POST',
    data: data.data,
    responseType: 'blob',
  });
};
